export default __webpack_public_path__ + "static/img4-169a51216f086a815ab7abeb8390f444.png";